import React, { useState, useEffect } from 'react';
import './testimonials.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import axios from 'axios';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get('https://apiportfoliov02.onrender.com/api/testimonials?sort=desc');
        if (res.status === 200 && res.data.length > 0) {
          setTestimonials(res.data);
          setHasError(false); // ✅ limpa erro quando conseguir
          setIsLoading(false);
        }
      } catch (err) {
        console.error("⛔ Erro ao carregar testimonials:", err);
        setHasError(true);
        setIsLoading(false);
      }
    };

    fetchTestimonials();

    // ✅ continua tentando até conseguir
    const interval = setInterval(fetchTestimonials, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      {isLoading ? (
        <p className="loading-msg">Carregando depoimentos...</p>
      ) : hasError && testimonials.length === 0 ? (
        <p className="error-msg">⚠️ Não foi possível carregar depoimentos.</p>
      ) : null}

      <Swiper
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {(hasError || testimonials.length === 0 ? [
          {
            _id: "1",
            name: "Exemplo Cliente",
            review: "Depoimento de exemplo em caso de erro no servidor.",
            avatar_url: "https://images.pexels.com/photos/5965566/pexels-photo-5965566.jpeg"
          }
        ] : testimonials).map(t => (
          <SwiperSlide key={t._id} className="testimonial">
            <div className="client__avatar">
              <img src={t.avatar_url} alt={t.name} />
            </div>
            <h5 className='client__name'>{t.name}</h5>
            <small className="client__review">{t.review}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
